import HeaderBidderPreset from '@/common/models/headerBidderPresets/HeaderBidderPreset';
import API from '@/org-app/api';
import {
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewHeaderBidderPreset(
    { commit },
    headerBidderPreset = HeaderBidderPreset.fromObject({
      id: -1,
    }),
  ) {
    commit(types.CREATE_HEADER_BIDDER_PRESET, headerBidderPreset);
    return headerBidderPreset;
  },
  getHeaderBidderPresets: createGetAllAction(
    API.instance.getHeaderBidderPresets,
    types.UPDATE_HEADER_BIDDER_PRESETS_LIST,
    'messages.failedToGetHeaderBidderPresets',
    true,
  ),
  getHeaderBidderPreset: createGetOneAction(
    API.instance.getHeaderBidderPreset,
    types.UPDATE_HEADER_BIDDER_PRESET,
    'messages.failedToGetHeaderBidderPresets',
  ),
  createHeaderBidderPresets: createPostAction(
    API.instance.postHeaderBidderPresets,
    types.SAVE_HEADER_BIDDER_PRESETS,
    'messages.failedToCreateHeaderBidderPresets',
  ),
  updateHeaderBidderPreset: createPutAction(
    API.instance.putHeaderBidderPreset,
    types.SAVE_HEADER_BIDDER_PRESETS,
    'messages.failedToUpdateHeaderBidderPresets',
  ),
  deleteHeaderBidderPreset: createDeleteAction(
    API.instance.deleteHeaderBidderPreset,
    types.DELETE_HEADER_BIDDER_PRESET,
    'messages.failedToDeleteHeaderBidderPresets',
  ),
};
